function VideoModal(youtubeVideoId) {
    document.addEventListener('keyup', e => {
        if (e.keyCode === 27) {
            const videoModal = document.querySelector('.video-modal');
            if (videoModal) this.closeModal(videoModal);
        }
    });

    this.createModal(youtubeVideoId);
    this.openModal();
};

VideoModal.prototype.createModal = function(youtubeVideoId) {
    this.modal = document.createElement('div');
    this.modal.classList.add('video-modal');

    const videoUrl = 'https://www.youtube.com/embed/' + youtubeVideoId + '?autoplay=1';
    const visualEl = '<iframe width="640" height="360" class="video-modal__video" src="' + videoUrl + '" frameborder="0" allowfullscreen></iframe>';

    this.modal.innerHTML =
        '<div class="video-modal__inner">' +
            '<div class="video-modal__wrapper">' +
                '<a class="video-modal__close-button">Close</a>' +
                '<div class="video-modal__video-wrapper">' + visualEl + '</div>' +
            '</div>' +
        '</div>'
    ;

    // Add the modal to the DOM
    this.modal.style.opacity = '0';
    document.body.appendChild(this.modal);

    // Init the close button
    this.modal.querySelector('.video-modal__close-button').addEventListener('click', e => {
        e.preventDefault();
        this.closeModal(this.parentElement);
    });

    // Init closing when clicking next to the video
    this.modal.addEventListener('click', e => {
        if (e.target.classList.contains('video-modal__video-wrapper')) {
            this.closeModal();
        }
    });

    // Add escape close listener
    document.addEventListener('keyup', e => {
        if (e.keyCode === 27) this.closeModal();
    });

    // Init iframe aspect ratio
    const iframe = this.modal.querySelector('iframe');
    const definedWidth = iframe.getAttribute('width');
    const definedHeight = iframe.getAttribute('height');
    const aspectRatio = [1, (definedHeight / definedWidth)];

    this.setIframeAspectRatio(iframe, aspectRatio);
    window.addEventListener('resize', _ => this.setIframeAspectRatio(iframe, aspectRatio));
};

VideoModal.prototype.openModal = function() {
    TweenLite.to(this.modal, 0.5, { opacity: 1, ease: Power2.easeInOut });
};

VideoModal.prototype.closeModal = function() {
    TweenLite.to(this.modal, 0.5, { opacity: 0, onComplete: _ => this.modal.parentElement.removeChild(this.modal) });
};

VideoModal.prototype.setIframeAspectRatio = function(iFrameElement, ratio) {
    iFrameElement.style.width = '';
    iFrameElement.style.height = '';

    let newHeight = (iFrameElement.offsetWidth / ratio[0]) * ratio[1];

    const offset = window.innerWidth >= 850 ? 200 : 100;

    if (newHeight > (window.innerHeight - offset)) {
        newHeight = window.innerHeight - offset;
        iFrameElement.style.width = (newHeight / ratio[1] * ratio[0]) + 'px';
    }

    iFrameElement.style.height = newHeight + 'px';
};